export const courseName = "全日制全端開發";
